<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
  >
    <div class="dialog-box">
      <div class="box-logo">
        <img src="./images/logo_jishujie@2x.png" class="logo">
        <div class="logo-text">天美贷官方小程序</div>
      </div>
      <div class="title">请使用微信小程序进入天美贷</div>
      <div class="sub-title">立领<span class="text-primary">50000</span>元提现额度</div>
      <img v-if="qrCodeData.length <= 0" src="./images/qr_code_wxmp.jpg" class="qrcode-image">
      <img v-else :src="`data:image/png;base64,${this.qrCodeData}`" class="qrcode-image">
      <div class="save-tip">请长按图片保存至相册</div>
      <div class="box-tips">
        <div class="item">
          <div class="index">1、</div>
          <div class="tips">保存图片至相册，使用微信“扫一扫”功能识别图片，进入小程序</div>
        </div>
        <div class="item">
          <div class="index">2、</div>
          <div class="tips">微信搜索小程序：天美贷极速借</div>
        </div>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
import axios from '@/assets/axios'
import { setKey, getKey } from '../../assets/utils'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      qrCodeData: ''
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.getShareQrcode()
      }
    }
  },
  methods: {
    async getShareQrcode () {
      const { data } = await axios.request({
        url: '/wechat/miniApp/share',
        method: 'POST',
        data: {
          shareType: 'QR_CODE'
      } })
      if (data.success) {
        this.qrCodeData = data.data.data
        const codeNo = data.data.codeNo
        const expTime = data.data.expTime
        this.recordSensorsData(codeNo, expTime)
      }
    },
    recordSensorsData (codeNo, expTime) {
      const storedCodeNo = getKey('qrCodeNo')
      const storedExpTime = getKey('qrCodeNoExpTime')
      // 获取当前时间戳
      const nowTime = new Date().getTime()
      // 如果当前时间戳大于存储的时间戳，说明已经过期
      if (!storedCodeNo || !storedExpTime || storedExpTime < nowTime) {
        // 记录新的codeNo和expTime
        setKey('qrCodeNo', codeNo)
        setKey('qrCodeNoExpTime', expTime)
        this.$sensors.track('PopupDisplay', { msg_name: '小程序引导弹窗', caseid: 'mini_pro', page_status: codeNo })
      } else {
        // 未过期
        this.$sensors.track('PopupDisplay', { msg_name: '小程序引导弹窗', caseid: 'mini_pro', page_status: storedCodeNo })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.dialog-box {
  text-align: center;
  padding: 0 38px 40px;
  .box-logo {
    display: flex;
    flex-direction: row;
    .logo {
      width: 40px;
      height: 40px;
    }
    .logo-text {
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 37px;
      margin-left: 8px;
    }
  }
  .qrcode-image {
    width: 380px;
    height: 380px;
    margin: 0 auto;
    margin-top: 40px;
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-top: 58px;
  }
  .sub-title {
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    .text-primary {
      color: #FF4633
    }
  }
  .save-tip {
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-top: 16px;
  }
  .box-tips {
    font-size: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    text-align: left;
    margin-top: 40px;
    > :last-child {
      margin-top: 10px;
    }
    .item {
      display: flex;
      flex-direction: row;
    }
  }
}
</style>